import { createContext, useContext, useState, useCallback, type ReactNode } from 'react';

interface SlotState {
  center: ReactNode;
  right: ReactNode;
}

interface SlotApi extends SlotState {
  setCenter: (node: ReactNode) => void;
  setRight: (node: ReactNode) => void;
}

const LayoutCtx = createContext<SlotApi | null>(null);

export function LayoutProvider({ children }: { children: ReactNode }) {
  const [slots, setSlots] = useState<SlotState>({ center: null, right: null });
  const setCenter = useCallback((center: ReactNode) => setSlots((s) => ({ ...s, center })), []);
  const setRight = useCallback((right: ReactNode) => setSlots((s) => ({ ...s, right })), []);

  return (
    <LayoutCtx.Provider value={{ ...slots, setCenter, setRight }}>{children}</LayoutCtx.Provider>
  );
}

export function useLayoutSlots(): SlotApi {
  const ctx = useContext(LayoutCtx);
  if (!ctx) throw new Error('useLayoutSlots must be used inside LayoutProvider');
  return ctx;
}
